import classNames from 'classnames';
import ReachAlert from '@reach/alert';

import SvgIcon from '../SvgIcon';

import IAlert from './types';
import useStyles from './styles';

function Alert({
  className,
  title,
  message: description,
  iconName,
  closeIconName = 'close-circle-gen',
  status,
  hasClose = true,
  onClose,
}: IAlert) {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, status, className)}>
      {iconName && <SvgIcon className={classNames(classes.typeIcon, status)} name={iconName} />}
      <ReachAlert type="polite" className={classes.textContent}>
        <p className={classNames(classes.title, status)}>{title}</p>
        {description && <p className={classNames(classes.description, status)}>{description}</p>}
      </ReachAlert>

      {onClose && hasClose && (
        <button
          className={classNames(classes.closeButton, status)}
          type="button"
          tabIndex={0}
          onClick={onClose}
        >
          <SvgIcon className={classNames(classes.closeIcon, status)} name={closeIconName} />
        </button>
      )}
    </div>
  );
}

export default Alert;
